module.exports = __webpack_public_path__ + "static/media/grid only 1.a88db938.png";